import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Alert, Button, Typography, Result } from "antd";
import { useIntl } from "react-intl";

import Find from "./find";
import History from "./history";
import { error } from "../../modules/messages";
import { get } from "../../modules/httpFunctions";
import LoadSkeleton from "../app/generic/loadSkeleton";
import { handleError } from "../../modules/errorLogger";
import { createQueryString } from "../../modules/crudOperations";

import "./index.css";

const { Title } = Typography;

function Tracking({ bigger, showInfo, showFind, showTitle, consignmentCode }) {
  const intl = useIntl();
  const colProps = {
    xs: { span: bigger ? 24 : 22 },
    sm: { span: bigger ? 24 : 22 },
    md: { span: bigger ? 24 : 22 },
    lg: { span: bigger ? 22 : 18 },
    xl: { span: bigger ? 18 : 16 },
    xxl: { span: bigger ? 16 : 14 },
  };
  const rowProps = {
    justify: "center",
    type: "flex",
  };

  const [used, setUsed] = useState();
  const [loading, setLoading] = useState();
  const [consignmentData, setConsignmentData] = useState();
  const getHistory = useCallback(
    (consignment) => {
      if (consignment) {
        setLoading(true);
        get(`tracking${createQueryString({ consignment })}`)
          .then((response) => {
            setConsignmentData(response.data);
            setLoading();
          })
          .catch((err) => {
            handleError(err);
            setConsignmentData("e");
            setLoading();
          });
      } else {
        error(
          intl.formatMessage({
            id: "tracking.emptyCode",
            defaultMessage:
              "Zadejte prosím číslo zásilky, číslo kusu nebo referenci!",
          })
        );
      }
    },
    [intl]
  );

  const handleButtonClick = useCallback(() => {
    setConsignmentData();
  }, [setConsignmentData]);

  useEffect(() => {
    consignmentCode && getHistory(consignmentCode);
  }, [getHistory, consignmentCode]);

  return (
    <Row {...rowProps} className="tracking-container">
      <Col {...colProps}>
        {consignmentData ? (
          <Row>
            <Col>
              <Row type="flex" gutter={[0, 45]}>
                <Col span={24}>
                  {consignmentData === "e" ? (
                    <Result
                      status="warning"
                      title={intl.formatMessage({
                        id: "tracking.serverError",
                        defaultMessage:
                          "Omlouváme se, ale server je momentálně nedostupný.",
                      })}
                    />
                  ) : consignmentData.success ? (
                    <History
                      full={showTitle}
                      showInfo={showInfo}
                      consignmentData={consignmentData.data}
                    />
                  ) : (
                    <Alert
                      message={intl.formatMessage({
                        id: "tracking.error",
                        defaultMessage: "Chyba",
                      })}
                      description={consignmentData.message}
                      type="error"
                      closable
                    />
                  )}
                </Col>
              </Row>
              {showTitle && (
                <Row gutter={[0, 45]} type="flex" justify="end">
                  <Col>
                    <Button type="primary" onClick={handleButtonClick}>
                      {intl.formatMessage({
                        id: "tracking.findNew",
                        defaultMessage: "Hledat novou zásilku",
                      })}
                    </Button>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              {showTitle && (
                <Title className="tracking-title">
                  {intl.formatMessage({
                    id: "tracking",
                    defaultMessage: "SLEDOVÁNÍ ZÁSILEK",
                  })}
                </Title>
              )}
              {showFind && (
                <Find
                  used={used}
                  setUsed={setUsed}
                  onClick={getHistory}
                  loading={loading}
                />
              )}
              {loading && <LoadSkeleton />}
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
}

export default Tracking;
